import { ThumbUpSmall } from '@wix/wix-ui-icons-common/on-stage/reactions';
export default ThumbUpSmall;
//# sourceMappingURL=thumbs-up-icon.js.map